import { useI18n } from 'vue-i18n';
import * as yup from 'yup';

export default () => {
  // Set Localization
  const { t } = useI18n();

  const schema = yup.object({
    type: yup.string().nullable().required(t('errorMessages.required')),
    showInfo: yup.boolean().nullable().optional(),
    is_encrypted: yup.boolean().nullable().optional(),
    data: yup.string().nullable().optional(),
    freedompay: yup
      .object({
        id: yup.string().nullable().optional(),
        freedompay_store_id: yup
          .string()
          .nullable()
          .when('$is_encrypted', {
            is: true,
            then: (schema) => schema.optional(),
            otherwise: (schema) => schema.required(t('errorMessages.required')),
          }),
        freedompay_terminal_id: yup
          .string()
          .nullable()
          .when('$is_encrypted', {
            is: true,
            then: (schema) => schema.optional(),
            otherwise: (schema) => schema.required(t('errorMessages.required')),
          }),
      })
      .optional(),
  });

  return { schema };
};
